<template>
  <div class="top-navbar sticky">
    <div class="game-icon"></div>
    <div class="game-info">
      <div class="game-name">{{ langData.gameName }}</div>
      <div class="game-type">{{ langData.gameType }}</div>
    </div>
    <div class="btn-list">
      <!-- 音乐控制按钮 -->
      <div
        class="music-btn"
        :class="{ active: musicState }"
        @click="switchMusic"
      >
        <div class="music-icon" :class="{ active: musicState }"></div>
      </div>

      <!-- YouTube按钮 -->
      <div
        class="youtube-btn"
        @click="
          jumpLink(
            'https://www.youtube.com/@RagnarokTheNewWorld',
            'YouTube按钮',
            '移动端顶栏'
          )
        "
      >
        <div class="hot-icon"></div>
      </div>

      <!-- Discord按钮 -->
      <div
        class="dc-btn"
        @click="
          jumpLink('https://discord.gg/pGbjenEwgN', 'Discord按钮', '移动端顶栏')
        "
      >
        <div class="hot-icon"></div>
      </div>

      <!-- Facebook按钮 -->
      <div
        class="fb-btn"
        @click="
          jumpLink(
            'https://www.facebook.com/RagnarokTheNewWorld.Gravity',
            'FB按钮',
            '移动端顶栏'
          )
        "
      ></div>

      <!-- 语言切换 -->
      <LangSwitcher class="mobile-lang-switcher" />

      <!-- 回到顶部按钮 -->
      <div class="back-top-btn" @click="scrollToTop"></div>
    </div>
  </div>
</template>

<script setup>
import { inject, ref } from "vue";
import LanguageHook from "@/hooks/language";
import LangSwitcher from "@/components/LangSwitcher.vue";

// 语言相关
const { langData } = LanguageHook();

// Props
const props = defineProps({
  musicState: {
    type: Boolean,
    default: false,
  },
});

// Emits
const emit = defineEmits(["switchMusic", "jumpLink", "scrollToTop"]);

// 方法
const switchMusic = () => {
  emit("switchMusic");
};

const jumpLink = (link, name, module) => {
  emit("jumpLink", link, name, module);
};

const scrollToTop = () => {
  emit("scrollToTop");
};
</script>

<style lang="less" scoped>
/* 移动端顶部导航栏样式 */
.top-navbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px 0 30px;
  box-sizing: border-box;
  width: 750px;
  height: 100px;
  background: url(../assets/images/m/menu.png) center/contain no-repeat;
  background-size: cover;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;

  .game-icon {
    margin-top: 40px;
    width: 120px;
    height: 120px;
    background: url(../assets/images/m/icon.png) center/contain no-repeat;
  }

  .game-info {
    margin-left: 10px;
    width: 200px;
    flex-shrink: 1;
    overflow: hidden;

    .game-name {
      font-size: 22px;
      line-height: 40px;
      font-weight: bold;
      color: #000000;
    }

    .game-type {
      font-size: 20px;
      color: #818080;
    }
  }

  .btn-list {
    flex: 1;
    min-width: 0;
    display: flex;
    gap: 10px;
    justify-content: flex-end;
    align-items: center;

    .mobile-lang-switcher {
      flex-shrink: 0;
      width: 50px;
      height: 50px;

      :deep(.lang-switcher-trigger) {
        width: 50px !important;
        height: 50px !important;
        background: #c89360 !important;
        border-radius: 50%;
        -webkit-mask-image: url(../assets/images/header/lang.png);
        mask-image: url(../assets/images/header/lang.png);
        -webkit-mask-size: 80%;
        mask-size: 80%;
        -webkit-mask-position: center;
        mask-position: center;
        -webkit-mask-repeat: no-repeat;
        mask-repeat: no-repeat;
      }
    }

    .dc-btn {
      width: 50px;
      height: 50px;
      background: url(../assets/images/aside/m-discord.png) center/contain
        no-repeat;
      cursor: pointer;
      position: relative;
    }

    .fb-btn {
      width: 50px;
      height: 50px;
      background: url(../assets/images/aside/m-facebook.png) center/contain
        no-repeat;
      cursor: pointer;
      position: relative;
    }

    .youtube-btn {
      width: 50px;
      height: 50px;
      background: url(../assets/images/aside/m-youtube.png) center/contain
        no-repeat;
      cursor: pointer;
      position: relative;
    }

    .music-btn {
      width: 50px;
      height: 50px;
      background: url(../assets/images/aside/m-music-off.png) center/contain
        no-repeat;
      cursor: pointer;
      position: relative;

      &.active {
        background: url(../assets/images/aside/m-music.png) center/contain
          no-repeat;
      }

      .music-icon {
        width: 100%;
        height: 100%;
      }
    }

    .back-top-btn {
      width: 50px;
      height: 50px;
      background: url(../assets/images/aside/back-top.png) center/contain
        no-repeat;
      cursor: pointer;
    }

    .hot-icon {
      position: absolute;
      top: -10px;
      right: 0px;
      width: 30px;
      height: 30px;
      background: no-repeat top url(../assets/images/aside/hot.png);
      background-size: contain;
    }
  }
}
</style>
